import type { ReactNode } from "react";
import classNames from "classnames";
import { Button } from "./Button";
import { ComponentColor } from "./types";

export const Alert = ({
    className,
    children,
    color = ComponentColor.Info,
    title,
    onClose,
}: AlertProps) => {
    const alertClasses = classNames(
        "alert",
        color === ComponentColor.Error ? "alert-error" : "",
        color === ComponentColor.Info ? "alert-info" : "",
        color === ComponentColor.Success ? "alert-success" : "",
        color === ComponentColor.Warning ? "alert-warning" : "",
        className,
    );

    return (
        <div className={alertClasses} role="alert">
            <div>
                {title && <div className="font-bold">{title}</div>}
                <div className="text-sm whitespace-pre-line">{children}</div>
            </div>
            {onClose && (
                <Button
                    className="btn-sm"
                    color={ComponentColor.Ghost}
                    aria-label="Dismiss"
                    onClick={onClose}
                >
                    ✕
                </Button>
            )}
        </div>
    );
};

interface AlertProps {
    className?: string;
    children?: ReactNode | string;
    color?: Extract<ComponentColor, "info" | "success" | "error" | "warning">;
    title?: string;
    onClose?: () => void;
}

export default Alert;
